import React, {useEffect} from 'react';
import {IntlProvider} from 'react-intl';
import {TranslationMessagesType} from "../types";
import {LocaleContext, useCreateLocaleContext} from "./context/LocaleContext";

interface LanguageProviderProps {
    messages: { [locale: string]: TranslationMessagesType };
    children: React.ReactNode;
}

export function LanguageProvider({messages, children}: LanguageProviderProps) {
    const {locale, changeLocale} = useCreateLocaleContext();

    useEffect(() => {
        document.documentElement.lang = locale;
    }, [locale]);

    return (
        <LocaleContext.Provider value={{locale, changeLocale}}>
            <IntlProvider locale={locale} messages={messages[locale]}>
                {React.Children.only(children)}
            </IntlProvider>
        </LocaleContext.Provider>
    );
}
